import DynatracePlugin from '@/plugins/dynatracePlugin';
import { Session } from '@/shared/util/session';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import { v4 as uuid } from '@/shared/util/uuid';
import { getAuthClient } from './auth';
import axios from 'axios';
import { useGlobalStore } from '@/stores/global/global.store';

let reqIndex = 0;

export const addHeader = (config: InternalAxiosRequestConfig, header: string, value: string) => {
  config.headers[header] = value;
};

export const setCorrelationId = () => {
  if (!Session.get('X-Correlation-ID')) {
    Session.set('X-Correlation-ID', uuid());
  }
};

export const dynatraceResponseInterceptor = (response: AxiosResponse) => response;
export const dynatraceResponseErrorInterceptor = (err: AxiosError) => {
  try {
    DynatracePlugin.reportCustomError('PC2_XHR_ERR', JSON.stringify(err), undefined, false);
  } catch (_error) {
    /* empty */
  }
  return Promise.reject(err);
};

export const sessionManagerRequestInterceptor = async (config: InternalAxiosRequestConfig) => {
  // ! have a better list of urls to bypass and a better way to track the list
  if (config.url?.includes('/pub/auditlog') || config.url?.includes('/revoke')) return config;
  const authClient = getAuthClient();
  const accessToken = await authClient.getAccessToken();
  if (accessToken) {
    addHeader(config, 'authorization', `Bearer ${accessToken}`);
  }
  return config;
};

export const sessionManagerRequestErrorInterceptor = (err: AxiosResponse) => err;

export const sessionManagerResponseInterceptor = (response: AxiosResponse) => response;

export const sessionManagerResponseErrorInterceptor = async (err: AxiosError) => {
  if (err.response?.status === 401) {
    const authClient = getAuthClient();
    const authenticated = await authClient.isAuthenticated();
    if (!authenticated) {
      await authClient.logout();
      return Promise.reject(err);
    }
    return axios.request(err.config as AxiosRequestConfig); // retry
  }
  return Promise.reject(err);
};

export const metadataRequestInterceptor = (config: InternalAxiosRequestConfig) => {
  Session.resetExpiration(); // ? for session timeout dialog

  const sourceId = window.localStorage.getItem('sourceId');
  if (sourceId) {
    addHeader(config, 'x-pri-source', `${window.localStorage.getItem('sourceId')}`);
  }

  const globalStore = useGlobalStore();
  addHeader(config, 'x-correlation-id', `${Session.get('X-Correlation-ID')}:${reqIndex++}`);
  addHeader(config, 'deviceDNA', globalStore.$state.deviceDNA);
  addHeader(config, 'deviceid', Session.get('deviceId', true) ?? '');
  const { appVersion, deviceInfo } = globalStore.$state.userSessionMeta;
  addHeader(config, 'x-pri-device', deviceInfo ? (deviceInfo.deviceModel ?? '') : '');
  addHeader(config, 'x-pri-os', deviceInfo ? (deviceInfo.deviceOsVersion ?? '') : '');
  addHeader(config, 'x-pri-platform', deviceInfo ? (deviceInfo.devicePlatform ?? '') : '');
  addHeader(config, 'x-pri-app', appVersion);

  return config;
};
